import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VerificarPacienteComponent } from './verificar-paciente.component';


const routes: Routes = [
  {
    path: '', 
    children: [
      { path: 'verificaPaciente', component: VerificarPacienteComponent, data: { titulo: 'Verificar Paciente AlmaMedis' } },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VerificarPacienteRoutingModule { }
